import {useEffect, useRef} from 'react';
import {useLocation, useNavigationType} from 'react-router-dom';

import NAVIGATION_TYPES from '@/consts/navigationTypes';
import modalService from '@/services/modal/modalService';
import {setDepth} from '@/services/route/routerService';

const useModalRoute = () => {
    const location = useLocation();
    const navigationType = useNavigationType();
    const route = modalService.parse(location.search);

    const depthRef = useRef(0);
    const wasOpenRef = useRef(false);
    const lastKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (lastKeyRef.current === location.key) return;
        lastKeyRef.current = location.key;

        const isOpen = route.isAnyOpen;

        if (isOpen && !wasOpenRef.current) depthRef.current = 1;
        else if (!isOpen) depthRef.current = 0;
        else if (navigationType === NAVIGATION_TYPES.PUSH) depthRef.current += 1;
        else if (navigationType === NAVIGATION_TYPES.POP) depthRef.current = Math.max(0, depthRef.current - 1);

        wasOpenRef.current = isOpen;
        setDepth(depthRef.current);
    }, [location.key, navigationType, route.isAnyOpen]);

    return route;
};

export default useModalRoute;
